import { format } from 'date-fns'
import { useSelector } from 'react-redux'

interface RequestsMonthsProps {
    requestsMonthsids?: number[]
}

interface RequestMonth {
    question_id: number
    month: string
}

interface RequestsEntities {
    requestsMonths?: Record<number, RequestMonth>
    questions?: Record<number, { question_name_filter: string }>
}

interface RequestsState {
    requests: {
        entities: RequestsEntities
    }
}

const RequestsMonths = ({ requestsMonthsids = [] }: RequestsMonthsProps) => {
    const { requestsMonths = {}, questions = {} } = useSelector(
        (state: RequestsState) => state.requests.entities,
    )
    const questionsIds = [
        ...new Set(
            requestsMonthsids.map(
                (requestsMonthId) => requestsMonths[requestsMonthId]?.question_id,
            ),
        ),
    ]

    return (
        <>
            {questionsIds.map((questionId) => {
                const months = requestsMonthsids
                    .map((requestsMonthId) => requestsMonths[requestsMonthId])
                    .filter(
                        (requestsMonth): requestsMonth is RequestMonth =>
                            requestsMonth !== undefined,
                    )
                    .filter((requestsMonth) => requestsMonth.question_id === questionId)
                    .sort((a, b) => a.month.localeCompare(b.month))
                    .map((requestsMonth) => format(new Date(requestsMonth.month), 'MMMM yyyy'))
                    .join(', ')

                if (!months) return null

                return (
                    <tr
                        key={`requests_months_${questionId}`}
                        className="hover:bg-grey-200 transition-colors">
                        <td className="py-1.5 pr-4 text-md text-neutral-600 font-medium align-top w-[180px]">
                            {questions[questionId]?.question_name_filter}
                        </td>
                        <td className="py-1.5 text-md text-neutral-900 align-top">{months}</td>
                    </tr>
                )
            })}
        </>
    )
}

export default RequestsMonths
